import { addToCart } from '../../utils/add-to-cart';
import { init as boldSubscriptionInit } from '../../templates/pdp/bold-subscription-widget';
import { getSampleButtonText, shouldDisabledSampleButton, updateAllSampleButtons, updateCartCounter } from '../product-samples/product-samples';
import { updateCartWarning } from '../../templates/cart';
import { showCartSideDraw } from '../../sections/cart-drawer';

export const AddToCartButton = {
  name: 'quickshop-add-to-cart-button',
  template: `#quickshop-add-to-cart-button`,
  props: [
    'qty',
    'selectedVariantId',
    'quickshopIsOpen',
    'isAvailable',
    'productHandle',
  ],
  data: () => ({
    cartButtonText: 'Add to Bag',
    disabled: false,
    addedToCart: false,
    hasContentSquareTrackingClassname: false,
    outOfStockButtonText: 'Out of Stock',
  }),
  methods: {
    onClickHandler: async function (e) {
      e.preventDefault();
      const _self = this;

      if (this.addedToCart) {
        window.location = '/checkout';
      } else {
        boldSubscriptionInit(document.querySelector('#quickshop_product_form'))
        const toggleSource = this.$root.xsellOptions?.source || '';
        addToCart({
          quantity: this.qty,
          productHandle: this.productHandle,
          selectedVariantID: this.selectedVariantId,
          source: toggleSource,
        });

        $(document).on('cart.requestComplete', function (event, cart) {
          _self.$emit('cart-added');
          showCartSideDraw();
          const text = getSampleButtonText(this.selectedVariantId);
          _self.disabled = shouldDisabledSampleButton(text);
          _self.cartButtonText = 'Continue to Checkout';
          _self.addedToCart = true;
          _self.hasContentSquareTrackingClassname = true;
          setTimeout(() => {
            updateAllSampleButtons();
            updateCartWarning();
            updateCartCounter(cart);
          }, 1000);
        });
      }
    },
    resetAddToCartCTA: function () {
      this.cartButtonText = 'Add to Bag';
      this.addedToCart = false;
      this.hasContentSquareTrackingClassname = false;
      this.disabled = false;
    },
  },
  watch: {
    quickshopIsOpen: function (newVal, oldVal) {
      /**
       * Reset the Quickshop Add To Cart CTA
       * We only want to call this when an item has been added to the cart
       * and when the user has reopened the quickshop sidebar
       */
      if (this.addedToCart && newVal === true) {
        this.resetAddToCartCTA();
      }
    },
  },
};
